import { FC } from 'react';

import AuthLayout from 'authentication/layouts/auth-layout';

import RoutesWithNotFound from 'common/config/routes/routesWithNotFound.util';

interface Props {
  children: JSX.Element[] | JSX.Element;
}

const AuthenticationRouting: FC<Props> = ({ children }) => {
  return (
    <AuthLayout>
      <RoutesWithNotFound>{children}</RoutesWithNotFound>
    </AuthLayout>
  );
};
export default AuthenticationRouting;
